import React, { useState } from "react";
import { useSelector } from "react-redux";

import "../../../css/createSourceModal.css";
import SwalAlertComp from "../../SwalAlert";
import DynamicsLeadLogin from "./DynamicsLeadLogin";
import ClipLoader from "react-spinners/ClipLoader";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";

const DynamicsLeadDestination = (props) => {
    const language = useSelector((state) => state.languagesState.languages);

    const [dynamicsName, setDynamicsName] = useState("");
    const [dynamicsCrmUrl, setDynamicsCrmUrl] = useState("");
    const [dynamicsBtn, setDynamicsBtn] = useState(false);
    const [urlError, setUrlError] = useState("");

    const [shouldRender, setShouldRender] = useState(true);

    // Function to validate HTTPS URL
    const validateHttpsUrl = (url) => {
        if (!url) {
            return "";
        }

        try {
            const urlObj = new URL(url);
            if (urlObj.protocol !== "https:") {
                return "URL must use HTTPS protocol";
            }
            return "";
        } catch (error) {
            return "Please enter a valid URL";
        }
    };

    const handleDynamicsName = (e) => {
        const inputValue = e.target.value;
        setDynamicsName(inputValue);

        // Enable button only if both name and URL are valid
        setDynamicsBtn(
            inputValue && dynamicsCrmUrl && !validateHttpsUrl(dynamicsCrmUrl),
        );
    };

    const handleDynamicsCrmUrl = (e) => {
        const inputValue = e.target.value;
        setDynamicsCrmUrl(inputValue);

        // Validate URL on change
        const error = validateHttpsUrl(inputValue);
        setUrlError(error);

        // Only enable button if both name and URL are valid
        setDynamicsBtn(dynamicsName && inputValue && !error);
    };

    const handleSuccess = (data) => {
        setShouldRender(false);
        if (props.onSuccess) {
            props.onSuccess(data);
        }
    };

    const handleError = (message) => {
        console.error(
            "[DEBUG] DynamicsLeadDestination - Error callback:",
            message,
        );
        SwalAlertComp({
            title: language?.delete_swal_modal?.failed ?? "Failed",
            message: message ?? "Connection failed",
            icon: "error",
        });
    };

    return (
        shouldRender && (
            <div>
                <FormControl className="mb-3" style={{ width: "100%" }}>
                    <TextField
                        name="name"
                        label={language?.source_modal?.name ?? "Name"}
                        variant="outlined"
                        onChange={handleDynamicsName}
                        placeholder={
                            language?.source_modal?.please_write_name ??
                            "Please Write Name"
                        }
                        value={dynamicsName}
                        required
                    />
                </FormControl>

                <FormControl className="mb-3" style={{ width: "100%" }}>
                    <TextField
                        name="crm_url"
                        label={language?.source_modal?.crm_url ?? "CRM URL"}
                        variant="outlined"
                        onChange={handleDynamicsCrmUrl}
                        placeholder="https://org.crm4.dynamics.com"
                        value={dynamicsCrmUrl}
                        required
                        error={!!urlError}
                        helperText={
                            urlError ||
                            "Enter your Microsoft Dynamics CRM URL (must be HTTPS)"
                        }
                    />
                </FormControl>

                <div className="position-relative overflow-hidden z-1">
                    {props.isButtonLoader !== undefined &&
                        props.isButtonLoader && (
                            <div className="circle-loader">
                                <ClipLoader color={"#000"} size={17} />
                            </div>
                        )}
                    <DynamicsLeadLogin
                        onSuccess={handleSuccess}
                        onError={handleError}
                        isButtonLoader={props?.isButtonLoader}
                        setIsButtonLoader={props?.setIsButtonLoader}
                        disabled={!dynamicsBtn}
                        crmUrl={dynamicsCrmUrl}
                        dynamicsName={dynamicsName}
                    />
                </div>
            </div>
        )
    );
};

export default DynamicsLeadDestination;
